var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Presentation = function Presentation(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M16.707 7.293a1 1 0 0 0-1.414 0L13 9.586l-1.293-1.293a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L11 10.414l1.293 1.293a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0 0-1.414Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 4a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2v9a3 3 0 0 1-3 3h-5v2h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2v-2H6a3 3 0 0 1-3-3V5a1 1 0 0 1-1-1Zm16 11a1 1 0 0 0 1-1V5H5v9a1 1 0 0 0 1 1h12Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Presentation;